export default "__VITE_ASSET__DQbjlFCG__"